import { queryClient } from 'api/services/queryClient';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { CreatePersonArg, CreatePersonResult } from 'lib/services/personsApi';
import { type MutationOptions, useMutation, type UseMutationResult } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useCreatePerson = ({
  onSuccess,
}: Pick<MutationOptions<CreatePersonResult, unknown, CreatePersonArg>, 'onSuccess'> = {}): UseMutationResult<
  CreatePersonResult,
  unknown,
  CreatePersonArg
> => {
  const { personsApiClient } = useServices();
  const appNotification = useAppNotifications();

  return useMutation(async (arg: CreatePersonArg) => await personsApiClient.create(arg), {
    mutationKey: MUTATION_KEYS.persons.create(),
    onError: error => {
      appNotification.error({
        message: 'There was an error while creating person',
        description: getErrorMessage(error),
      });
    },
    onSuccess: (data, variables, context) => {
      appNotification.success({
        message: `Person created`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.persons.all());
      onSuccess?.(data, variables, context);
    },
  });
};
